import {render} from 'react-dom';
import ProductPage from "./product-page";

const productPageRoot = document.getElementById('product-page-root');

if (productPageRoot) {
    render(<ProductPage />, productPageRoot as HTMLElement);
}